var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.remainingAmountFreeAboveRate)?_c('div',{staticClass:"product__add-to-cart__delivery"},[_c(_setup.AzIcon,{staticClass:"product__add-to-cart__delivery__icon",attrs:{"icon-name":"package"}}),_vm._v(" "),_c('p',{staticClass:"product__add-to-cart__delivery__text"},[_vm._v("\n    "+_vm._s(_vm.$t('addToCart.freeDeliveryAbove', {
        country: _vm.$t(_setup.getCountryLabelByCode(_setup.country)),
        amount: _vm.$n(_setup.remainingAmountFreeAboveRate, {
          style: 'currency',
          currency: _setup.currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }),
      }))+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }